import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import SwipeAdapter from "./utils/SwipeAdapter";
import { ESwipeGesture } from './utils/SwipeAdapter';
export * from './utils/SwipeAdapter';
export default React.memo(function SwipeWrapper({ children, onStartSwipe, onShortSwipe, onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, onMoveXSwipe, onMoveYSwipe, onCancelSwipe, gestureMinLength, className }) {
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        if (!containerRef.current)
            return;
    }, [containerRef]);
    React.useEffect(() => {
        let swipeAdapter = null;
        if (containerRef.current) {
            swipeAdapter = SwipeAdapter(containerRef.current, { gestureMinLength: gestureMinLength });
            swipeAdapter.init();
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_START, (evt) => onStartSwipe === null || onStartSwipe === void 0 ? void 0 : onStartSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_SHORT, (evt) => onShortSwipe === null || onShortSwipe === void 0 ? void 0 : onShortSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_RIGHT, (evt) => onRightSwipe === null || onRightSwipe === void 0 ? void 0 : onRightSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_LEFT, (evt) => onLeftSwipe === null || onLeftSwipe === void 0 ? void 0 : onLeftSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_UP, (evt) => onUpSwipe === null || onUpSwipe === void 0 ? void 0 : onUpSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_DOWN, (evt) => onDownSwipe === null || onDownSwipe === void 0 ? void 0 : onDownSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_MOVE_X, (evt) => onMoveXSwipe === null || onMoveXSwipe === void 0 ? void 0 : onMoveXSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_MOVE_Y, (evt) => onMoveYSwipe === null || onMoveYSwipe === void 0 ? void 0 : onMoveYSwipe(evt));
            swipeAdapter.onSwipe(ESwipeGesture.SWIPE_CANCEL, (evt) => onCancelSwipe === null || onCancelSwipe === void 0 ? void 0 : onCancelSwipe(evt));
        }
        return () => {
            swipeAdapter === null || swipeAdapter === void 0 ? void 0 : swipeAdapter.offSwipeAll();
            swipeAdapter === null || swipeAdapter === void 0 ? void 0 : swipeAdapter.destroy();
        };
    }, []);
    return (_jsx(SwipeAdapterContainer, { className: `swipe-wrapper-ui ${className ? ` ${className}` : ``}`, ref: containerRef, children: children }));
});
const SwipeAdapterContainer = styled.div `

`;
